import React, { useState } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'

import { Space, Grid, Popup, Dropdown, Image, Button, Toast, List, Divider } from 'antd-mobile'
import { AudioOutlined, PictureOutlined, TranslationOutlined } from '@ant-design/icons'

import { useAuth } from '../../contexts/AuthContextProvider'
import LayoutContextProvider from '../../contexts/LayoutContextProvider'
import Logo from '../../assets/images/svg/logo.svg'
import menuIcon from '../../assets/images/svg/menu.svg'
import statIcon from '../../assets/images/svg/stat.svg'

const AdminLayout = () => {
  const navigate = useNavigate()
  const { firebaseLogout } = useAuth()
  const [visibleMenu1, setVisibleMenu1] = useState(false)

  const signOut = async () => {
    try {
      await firebaseLogout()
      setVisibleMenu1(false)
    } catch (error) {
      if (error?.message) {
        Toast.show({
          content: error.message
        })
      }
    }
  }

  return (
    <>
      <Grid columns={3} style={{ margin: 16 }}>
        <Grid.Item>
          <Space justify='start' block>
            <Button fill='none' style={{ marginTop: 8 }} onClick={() => setVisibleMenu1(true)}><Image src={menuIcon} height={12} fit='contain' /></Button>
            <Popup
              visible={visibleMenu1}
              onMaskClick={() => setVisibleMenu1(false)}
              onClose={() => setVisibleMenu1(false)}
              position='left'
              bodyStyle={{ height: '100vh' }}
            >
              <div style={{ height: 24 }}></div>
              <List>
                <List.Item
                  prefix={<AudioOutlined />}
                  onClick={() => {
                    setVisibleMenu1(false)
                    navigate('/admin/conversations')
                  }}>
                  Conversation
                </List.Item>
                <List.Item
                  prefix={<PictureOutlined />}
                  onClick={() => {
                    setVisibleMenu1(false)
                    navigate('/admin/images')
                  }}>
                  Image
                </List.Item>
                <List.Item
                  prefix={<TranslationOutlined />}
                  onClick={() => {
                    setVisibleMenu1(false)
                    navigate('/admin/vocab')
                  }}>
                  Vocabulary
                </List.Item>
              </List>
              <Button color='primary' shape='rounded' fill='outline' onClick={() => signOut()} style={{ bottom: 16, margin: '96px 32px' }}>Sign out</Button>
            </Popup>
          </Space>
        </Grid.Item>
        <Grid.Item>
          <Space justify='center' block>
            <Image src={Logo} height={24} fit='contain' />
          </Space>
        </Grid.Item>
        <Grid.Item>
          <Space justify='end' block>
            <Dropdown arrowIcon={<Image src={statIcon} height={12} fit='contain' />}>
              <Dropdown.Item key='menu-right'>
                Stat
              </Dropdown.Item>
            </Dropdown>
          </Space>
        </Grid.Item>
      </Grid>
      <Divider />
      <LayoutContextProvider>
        <div style={{ margin: '8px 16px' }}>
          <Outlet />
        </div>
      </LayoutContextProvider>
    </>
  )
}

export default AdminLayout
